import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aea66b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = { class: "white-block nongfu-button-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "方式一：前往浏览器粘贴链接", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy-tips" }, "请复制以下链接在浏览器打开并完成保单批改", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "方式二：微信扫码批改", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy-tips" }, "截图保存二维码并打开微信扫一扫", -1))
const _hoisted_7 = { class: "qrcode-wrap" }

import { onMounted, onUnmounted } from 'vue'
import { Button, Divider } from 'vant'
import { showToastFail, showToastSuccess } from '@/utils/tools'
import ClipboardJS from 'clipboard'
import AppHeader from '@/components/Header.vue'
import Qrcode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'pingan-offline-page',
  setup(__props) {

// 保单提交后的页面, 小程序专用
const link = ' https://doc.weixin.qq.com/forms/AE4AtAdWAAwAFEAQQZWAMsHUHcnz8MT6f'

onMounted(() => {
  const clipbordItem = new ClipboardJS('#copyItem', {
    text() {
      return link
    },
  })
  clipbordItem.on('success', function (e) {
    showToastSuccess('复制成功')
    e.clearSelection()
  })

  clipbordItem.on('error', function (e) {
    showToastFail('复制失败')
  })
})

onUnmounted(() => {})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "保单批改" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", { class: "copy-url" }, _toDisplayString(link)),
        _createVNode(_unref(Button), {
          class: "copy-button",
          id: "copyItem"
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制链接")
          ]),
          _: 1
        }),
        _createVNode(_unref(Divider), { class: "divider" }),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(Qrcode), {
            value: link,
            options: {
            width: 120,
            margin: 1,
          }
          })
        ])
      ])
    ])
  ], 64))
}
}

})